import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const isYouTubeLink = (url) => {
    return url && (url.includes("youtube.com") || url.includes("youtu.be"));
  };

  const getEmbedUrl = (url) => {
    if (url.includes("youtu.be")) {
      return "https://www.youtube.com/embed/" + url.split("/").pop();
    } else if (url.includes("watch?v=")) {
      return "https://www.youtube.com/embed/" + url.split("v=")[1];
    }
    return url;
  };

  return (
    <Card className="project-card-view">
      {props.videoPath ? (
        isYouTubeLink(props.videoPath) ? (
          <div className="video-container" style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
            <iframe
              src={getEmbedUrl(props.videoPath)}
              title={props.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: "5px" }}
            />
          </div>
        ) : (
          <video
            width="100%"
            height="auto"
            controls
            style={{ borderRadius: "5px" }}
          >
            <source src={props.videoPath} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      ) : (
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      )}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {/* Hide GitHub button if it's a video project */}
        {!props.videoPath && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}
        {"\n"}
        {"\n"}

        {!props.isBlog && props.demoLink && !props.videoPath && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"View"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
